import React, { useEffect } from 'react';
import OvertimeRecordReportDataTable from './OvertimeRecordReportDataTable';

const OvertimeRecordReportIndex = ({ rrhh }) => {
  useEffect(() => window.scrollTo(0, 0), []);
  return <OvertimeRecordReportDataTable rrhh={rrhh} />;
};

export default OvertimeRecordReportIndex;
